const welcome = {
    title: '管理者コンソールへようこそ',
    description: '管理者コンソールは、コーディングの必要がないLogtoを管理するためのWebアプリです。まずはアカウントを作成しましょう。このアカウントで自分自身または会社の代表者としてLogtoを管理することができます。',
    create_account: 'アカウントを作成する',
};
export default Object.freeze(welcome);
